import axiosBase from "axios";
import { retryableGet } from "@/lib/utils/networkRetry";

/** microCMS の contest.version が 2 のとき、新しい詳細画面を使う */
export function isContestVersion2(version: unknown): boolean {
  return version === 2;
}

/**
 * `/event/contest/:id` を `/event/contest/:id/detail` にする。
 * クエリとハッシュは残す。すでに detail や、コンテスト以外のパスなら null。
 */
export function toContestV2DetailFullPath(fullPath: string): string | null {
  const hashIndex = fullPath.indexOf("#");
  const withoutHash = hashIndex >= 0 ? fullPath.slice(0, hashIndex) : fullPath;
  const hash = hashIndex >= 0 ? fullPath.slice(hashIndex) : "";
  const queryIndex = withoutHash.indexOf("?");
  const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : "";
  const match = /^\/event\/contest\/([^/]+)$/.exec(path);
  if (!match || match[1] === "entries" || match[1] === "profile") return null;
  return `/event/contest/${match[1]}/detail${query}${hash}`;
}

/** 取得できない、または V2 でないときは null */
export async function fetchContestV2DetailPath(id: string, fullPath: string): Promise<string | null> {
  const detailPath = toContestV2DetailFullPath(fullPath);
  if (!detailPath) return null;

  try {
    const client = axiosBase.create({
      baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
      headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
    });
    const response = await retryableGet<{ version?: unknown }>(client, `/contest/${encodeURIComponent(id)}`);
    if (!isContestVersion2(response.data?.version)) return null;
    return detailPath;
  } catch {
    return null;
  }
}
